import './utils/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { CssBaseline, ThemeProvider } from '@mui/material';

import App from 'ui/App';
import {
  RouterProvider,
  IntlProvider,
  TableViewProvider,
  AuthenticationProvider,
  DetailViewProvider,
} from 'providers';
import { preLoadSetup } from 'utils/preLoadSetup';
import { defaultTheme } from 'theme';

import * as serviceWorker from './serviceWorker';

preLoadSetup();

ReactDOM.render(
  <ThemeProvider theme={defaultTheme}>
    <CssBaseline />
    <AuthenticationProvider>
      <IntlProvider>
        <RouterProvider>
          <TableViewProvider>
            <DetailViewProvider>
              <App />
            </DetailViewProvider>
          </TableViewProvider>
        </RouterProvider>
      </IntlProvider>
    </AuthenticationProvider>
  </ThemeProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
